import { Alert, Anchor, Center, Loader, Paper, Stack } from '@mantine/core'
import { IconLock, IconShieldLock } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { observer } from 'mobx-react-lite'
import { Link } from 'wouter'

import { Screen } from '@/components/Screen'
import { useGlobalState } from '@/hooks/useGlobalState'
import { useHasPublishedModule } from '@/hooks/useHasPublishedModule'
import { getRoutePath } from '@/utils/navigation'

import { AccessSettingsPanel } from './AccessSettingsPanel'
import { copy } from './copy'
import { DeleteChannelCard } from './DeleteChannelCard'
import { WebSetupCard } from './WebSetupCard'

export function AccessScreen() {
  const hasPublishedModule = useHasPublishedModule()

  return (
    <Screen title={copy.screen.title} icon={IconShieldLock}>
      {hasPublishedModule === undefined ? (
        <Center py="xl">
          <Loader />
        </Center>
      ) : hasPublishedModule ? (
        <AccessSettingsPanel />
      ) : (
        <LockedAccess />
      )}
    </Screen>
  )
}

/** Until the channel publishes a module, access can't be set up, but Web Setup and deleting the channel still can. */
const LockedAccess = observer(function LockedAccess() {
  const { api, authenticationStore } = useGlobalState()
  const sponsorInfoQuery = useQuery({ queryKey: ['sponsor', 'info'], queryFn: () => api.getSponsorInfo() })
  const channelName = sponsorInfoQuery.data?.name ?? authenticationStore.user?.sponsorName ?? ''

  return (
    <Stack gap="lg">
      <Alert variant="light" color="orange" icon={<IconLock size={18} />} title={copy.screen.lockedHint}>
        <Anchor component={Link} to={getRoutePath('contentModules')} size="sm" fw={600}>
          {copy.screen.lockedLink}
        </Anchor>
      </Alert>
      <Paper radius="md" p="lg" shadow="sm" px="xl">
        <Stack gap="lg">
          <WebSetupCard />
          <DeleteChannelCard channelName={channelName} />
        </Stack>
      </Paper>
    </Stack>
  )
})
